(function () {
  if (window.MavenProductCrossSellSliderLoaded) return;
  window.MavenProductCrossSellSliderLoaded = true;

  function initialize(root) {
    (root || document).querySelectorAll('[data-cross-sell-slider]').forEach(function (slider) {
      if (slider.dataset.crossSellReady === 'true') return;
      slider.dataset.crossSellReady = 'true';

      var track = slider.querySelector('[data-cross-sell-track]');
      var previous = slider.querySelector('[data-cross-sell-previous]');
      var next = slider.querySelector('[data-cross-sell-next]');
      var pointerStart = null;
      var dragged = false;

      function updateArrows() {
        var scrollable = track.scrollWidth > track.clientWidth + 1;
        previous.disabled = !scrollable || track.scrollLeft <= 1;
        next.disabled = !scrollable || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      function scrollStep() {
        var card = track.querySelector('[data-cross-sell-card]');
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }

      track.addEventListener('pointerdown', function (event) {
        pointerStart = event.clientX;
        dragged = false;
      });
      track.addEventListener('pointermove', function (event) {
        if (pointerStart !== null && Math.abs(event.clientX - pointerStart) > 6) dragged = true;
      });
      track.addEventListener('pointerup', function () {
        pointerStart = null;
        if (dragged) window.setTimeout(function () { dragged = false; }, 250);
      });
      track.addEventListener('pointercancel', function () { pointerStart = null; dragged = false; });

      track.addEventListener('click', function (event) {
        var card = event.target.closest('[data-cross-sell-card]');
        if (!card || card.disabled || dragged) {
          if (dragged) event.preventDefault();
          return;
        }
        var select = !card.classList.contains('is-selected');
        slider.querySelectorAll('[data-cross-sell-card]').forEach(function (item) {
          var active = item === card && select;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(updateArrows).observe(track);
      } else {
        window.addEventListener('resize', updateArrows);
      }
      updateArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
